import { QConfigPublishValidationErrorCode } from '@exam-management/qconfig-detail';
import { type MultipleFieldErrors } from 'react-hook-form';

interface PublishManualErrors {
  key: QConfigPublishValidationErrorCode;
  fieldName: string;
  types: MultipleFieldErrors | undefined;
}

export const publishManualErrors: PublishManualErrors[] = [
  {
    key: QConfigPublishValidationErrorCode.PASSING_CRITERIA_NOT_DEFINED,
    fieldName: 'passingCriteria.overall.root',
    types: undefined,
  },
  {
    key: QConfigPublishValidationErrorCode.EXAM_TIMING_NOT_DEFINED,
    fieldName: 'examTiming.option.root',
    types: undefined,
  },
  {
    key: QConfigPublishValidationErrorCode.QUESTION_RANDOMIZATION_NOT_DEFINED,
    fieldName: 'randomization.root',
    types: undefined,
  },
  {
    key: QConfigPublishValidationErrorCode.Q_CONFIG_STRUCTURES_ON_TIME_LIMIT_NOT_COMPLETE,
    fieldName: 'examTiming.structures.root',
    types: {
      validate: QConfigPublishValidationErrorCode.Q_CONFIG_STRUCTURES_ON_TIME_LIMIT_NOT_COMPLETE,
    },
  },
];
